import {AbstractDTO} from "@signature-it/ngx-generic/models";


export class SolrPreviewTaxonomyEntityConfig extends AbstractDTO{
    isOpenByDefaultField: string;
    taxonomyDefaultPreview: string;
    taxonomyChildrenToggleParent: string;

    constructor(attributes?: object) {
        super(attributes);
        attributes = attributes ? attributes : {};
        this.isOpenByDefaultField  = attributes['is-open-by-default-field'] || attributes['isOpenByDefaultField'] || '';
        this.taxonomyDefaultPreview  = attributes['taxonomy-default-preview'] || attributes['taxonomyDefaultPreview'] ||'';
        this.taxonomyChildrenToggleParent  = attributes['taxonomy-children-toggle-parent'] || attributes['taxonomyChildrenToggleParent'] ||'';
    }
}
